import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => setMenuOpen(false);

    return (
        <header className="App-header">
            <Link to="/" className="header-logo" onClick={closeMenu}>
                PDF Converter
            </Link>

            <button
                className="header-menu-toggle"
                aria-label="Toggle navigation menu"
                aria-expanded={menuOpen}
                onClick={() => setMenuOpen((v) => !v)}
            >
                <span />
                <span />
                <span />
            </button>

            <nav className={`header-nav ${menuOpen ? 'is-open' : ''}`}>
                <NavLink to="/" end onClick={closeMenu}>Home</NavLink>
                <NavLink to="/word-to-pdf" onClick={closeMenu}>Word&nbsp;to&nbsp;PDF</NavLink>
                <NavLink to="/image-to-pdf" onClick={closeMenu}>Image&nbsp;to&nbsp;PDF</NavLink>
                <NavLink to="/compress-pdf" onClick={closeMenu}>Compress</NavLink>
                <NavLink to="/pdf-to-image" onClick={closeMenu}>PDF&nbsp;to&nbsp;Image</NavLink>
                <NavLink to="/pdf-to-word" onClick={closeMenu}>PDF&nbsp;to&nbsp;Word</NavLink>
                <NavLink to="/blog" onClick={closeMenu}>Blog</NavLink>
                <NavLink to="/about" onClick={closeMenu}>About</NavLink>
                <NavLink to="/contact" onClick={closeMenu}>Contact</NavLink>
            </nav>
        </header>
    );
};

export default Header;
